import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import CarouselItem from "../carousel/carouselitem.component";
import Moment from "react-moment";
import 'moment/locale/ro';
import moment from 'moment';

class MoviesResultsSoonInCinema extends Component {

    getCards = () => {
        let markup = [];
        if(this.props.cards.resp) {

            for(let i=0; i< this.props.cards.resp.length; i++) {

                if(this.props.cards.resp[i]['films'].length > 0) {
                    markup.push(
                        <div key={i} className="col-12">
                            <span className="headline-button white-text filter-button selected">
                                { this.props.cards.resp[i]['film_release_day'] }
                            </span>
                        </div>
                    );


                    for(let j=0; j< this.props.cards.resp[i]['films'].length; j++) {
                        markup.push(
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-15 mb-4" key={this.props.cards.resp[i]['films'][j].film_id}>
                                <CarouselItem card={ this.props.cards.resp[i]['films'][j] } component="soon-in-cinema"/>
                            </div>
                        )
                    };
                }
            };
        }

        return markup;
    }

    /*getCards = () => {
        const newData = {};
        this.props.cards.map((movie, i) => {
            if(newData.hasOwnProperty(movie['film_release_date'])){
                newData[movie['film_release_date']].push(movie);
            } else{
                newData[movie['film_release_date']] = [movie];
            }
        });

        let markup = [];
        for(let movieDate in newData) {
            const headlineDate = moment(movieDate * 1000).format('DD MMMM');
            const iterator = movieDate + (Math.floor(Math.random() * 9999) + 1);
            markup.push(
                <div key={iterator} className="col-12">
                    <span className="headline-button white-text filter-button selected">
                        { headlineDate }
                    </span>
                </div>
            );

            for(const el in newData[movieDate]) {
                const index = movieDate + el;
                markup.push(
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-15 mb-4" key={index}>
                        <CarouselItem card={ newData[movieDate][el] }/>
                    </div>
                )
            }
        }

        return markup;
    };*/



    render() {
        return (
            <Fragment>
                <div className="movie-results">
                    {
                        this.getCards().length !== 0 ?
                        (
                            <Fragment>
                                <p className="headline-results-soon-in-cinema white-text">La cinema în luna { this.props.selectedMonth }</p>
                                <div className="row">
                                    { this.getCards() }
                                </div>
                            </Fragment>
                        ) :
                        <p className="text-center white-text">Nu există filme conform filtrului selectat</p>
                    }
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(MoviesResultsSoonInCinema);



// WEBPACK FOOTER //
// ./src/SHARED/components/movieresultssoonincinema/movieresultssoonincinema.component.js